var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videoPage"},[_c('div',{staticClass:"videoBox"},[_c('LivePlayer',{staticClass:"mb10 mySelfVideo",attrs:{"videoUrl":_vm.vUrl,"autoplay":"","live":"","stretch":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }